import React, {useRef, useEffect, useState} from "react";
import defaultImage from "./assets/default-cover.png";

function ActivityCoverImage({ imageUrl, height, width, borderRadius }) {

  const [resizeHeight, setResizeHeight] = useState(0);
  const imageRef = useRef(null);

   useEffect(() => {
    if (!imageRef.current && !height) return;

    const observer = new ResizeObserver(() => {
      imageRef.current && setResizeHeight(imageRef.current.clientWidth/2)
    });
    observer.observe(document.body);

    return () => observer.disconnect();
  }, [imageRef, height]);

  return (
    <img
      src={imageUrl || defaultImage}
      alt="cover"
      width={width}
      height={height || resizeHeight}
      style={{
        borderRadius,
        objectFit: 'cover'
      }}
      ref={imageRef}
    />
  );
}

export default ActivityCoverImage;
